import { WorkAtHeightChecklist } from "./WorkAtHeightChecklist";
import { ScaffoldingChecklist } from "./ScaffoldingChecklist";
import { ClosedSpaceChecklist } from "./ClosedSpaceChecklist";
import { AsbestosChecklist } from "./AsbestosChecklist";
import { HydrogenSulphideChecklist } from "./HydrogenSulphideChecklist";
import { BeefGasChecklist } from "./BeefGasChecklist";
import { HeavyLiftingChecklist } from "./HeavyLiftingChecklist";
import { ExcavationAndPolingChecklist } from "./ExcavationAndPolingChecklist";
import { RaftChecklist } from "./RaftChecklist";
import { DivingChecklist } from "./DivingChecklist";
import RiskIdentificationsFormState from "../../forms/Permits/Conditions/RiskIdentificationsFormState";
import { formElement } from "../../forms/FormElement";
import { ScaffoldingConstructionChecklist } from "./ScaffoldingConstructionChecklist";
import { ScaffoldingWorkChecklist } from "./ScaffoldingWorkChecklist";
import { RadioButtonOption, SignatureType } from "../../../common/enums";
import { Signature_normalize } from "../../Signature";

export type RiskIdentifications = {
    isWorkAtHeightIncludedInPrint: boolean;
    workAtHeightChecklist: WorkAtHeightChecklist;
    isScaffoldingIncludedInPrint: boolean;
    scaffoldingChecklist: ScaffoldingChecklist;
    scaffoldingConstruction: boolean;
    scaffoldingConstructionChecklist: ScaffoldingConstructionChecklist;
    scaffoldingWork: boolean;
    scaffoldingWorkChecklist: ScaffoldingWorkChecklist;
    isClosedSpaceIncludedInPrint: boolean;
    closedSpaceChecklist: ClosedSpaceChecklist;
    isAsbestosIncludedInPrint: boolean;
    asbetestosChecklist: AsbestosChecklist;
    isHydrogenSulphideIncludedInPrint: boolean;
    hydrogenSulphideChecklist: HydrogenSulphideChecklist;
    isBeefGasIncludedInPrint: boolean;
    beefGasChecklist: BeefGasChecklist;
    isHeavyLiftingIncludedInPrint: boolean;
    heavyLiftingChecklist: HeavyLiftingChecklist;
    isExcavationAndPolingIncludedInPrint: boolean;
    excavationAndPolingChecklist: ExcavationAndPolingChecklist;
    isRaftIncludedInPrint: boolean;
    raftChecklist: RaftChecklist;
    isDivingIncludedInPrint: boolean;
    divingChecklist: DivingChecklist;
    interventionOnProcessEquipment: boolean;
};

export function RiskIdentifications_toFormState(
    riskIdentifications: RiskIdentifications
): RiskIdentificationsFormState {
    const asbestosChecklist = riskIdentifications.asbetestosChecklist;
    const beefGasChecklist = riskIdentifications.beefGasChecklist;
    const closedSpaceChecklist = riskIdentifications.closedSpaceChecklist;
    const excavationAndPolingChecklist = riskIdentifications.excavationAndPolingChecklist;
    const heavyLiftingChecklist = riskIdentifications.heavyLiftingChecklist;
    const hydrogenSulphideChecklist = riskIdentifications.hydrogenSulphideChecklist;
    const scaffoldingChecklist = riskIdentifications.scaffoldingChecklist;
    const scaffoldingConstructionChecklist = riskIdentifications.scaffoldingConstructionChecklist;
    const scaffoldingWorkChecklist = riskIdentifications.scaffoldingWorkChecklist;
    const workAtHeightChecklist = riskIdentifications.workAtHeightChecklist;

    return {
        asbetestosChecklist: {
            areMasksFittedForRespPerson: formElement(asbestosChecklist.areMasksFittedForRespPerson),
            areOwnMachinesUsedForSanitation: formElement(asbestosChecklist.areOwnMachinesUsedForSanitation),
            externalPersonalIsContracted: formElement(asbestosChecklist.externalPersonalIsContracted),
            hasApprovalFromEnvironmentalAgency: formElement(asbestosChecklist.hasApprovalFromEnvironmentalAgency),
            hasCorrectDocuments: formElement(asbestosChecklist.hasCorrectDocuments),
            hasSignForAsbestos: formElement(asbestosChecklist.hasSignForAsbestos),
            isSanitisedFromAsbestosDust: formElement(asbestosChecklist.isSanitisedFromAsbestosDust),
            isTotalTimeForSanitationMoreThanOneHour: formElement(
                asbestosChecklist.isTotalTimeForSanitationMoreThanOneHour
            ),
            isWholeMaskWithCompressedAirUsed: formElement(asbestosChecklist.isWholeMaskWithCompressedAirUsed),
            leaderAndPersonalHaveCorrectEducation: formElement(asbestosChecklist.leaderAndPersonalHaveCorrectEducation),
            masksAreStoredAccordingAccordingToRules: formElement(
                asbestosChecklist.masksAreStoredAccordingAccordingToRules
            ),
            hasApprovalForThisProject: formElement(asbestosChecklist.hasApprovalForThisProject)
        },
        beefGasChecklist: {
            isContinousGasMeasurementsInPlace: formElement(beefGasChecklist.isContinousGasMeasurementsInPlace),
            isContinuousVentilationInPlace: formElement(beefGasChecklist.isContinuousVentilationInPlace),
            isFreshAirMaskForEveryone: formElement(beefGasChecklist.isFreshAirMaskForEveryone),
            isPortableGasMeasurementAlarmAvailableForEveryone: formElement(
                beefGasChecklist.isPortableGasMeasurementAlarmAvailableForEveryone
            ),
            needsFreshAirDevice: formElement(beefGasChecklist.needsFreshAirDevice),
            isFreshAirMaskNeededDuringWork: formElement(beefGasChecklist.isFreshAirMaskNeededDuringWork),
            isContinuousVentilationNeeded: formElement(beefGasChecklist.isContinuousVentilationNeeded),
            isOxygenLevelGasMeterAvailable: formElement(beefGasChecklist.isOxygenLevelGasMeterAvailable),
            isContinousGasMeasurementsInPlaceForEntirityOfWork: formElement(
                beefGasChecklist.isContinousGasMeasurementsInPlaceForEntirityOfWork
            ),
            isWindDirectionConsideredDuringWork: formElement(beefGasChecklist.isWindDirectionConsideredDuringWork)
        },
        closedSpaceChecklist: {
            areAllTermsMet: formElement(closedSpaceChecklist.areAllTermsMet),
            areGasMeasurementsPerformed: formElement(closedSpaceChecklist.areGasMeasurementsPerformed),
            areGasMeasurementsPerformedInClosedSpace: formElement(
                closedSpaceChecklist.areGasMeasurementsPerformedInClosedSpace
            ),
            areWarningSignsOnManholes: formElement(closedSpaceChecklist.areWarningSignsOnManholes),
            hasRescueHarness: formElement(closedSpaceChecklist.hasRescueHarness),
            isLightningSufficient: formElement(closedSpaceChecklist.isLightningSufficient),
            isManHoleGuardAvailable: formElement(closedSpaceChecklist.isManHoleGuardAvailable),
            isMechanicalVentilation: formElement(closedSpaceChecklist.isMechanicalVentilation),
            isPersonalAtEntryToClosedSpace: formElement(closedSpaceChecklist.isPersonalAtEntryToClosedSpace),
            isThereARescuePlan: formElement(closedSpaceChecklist.isThereARescuePlan),
            isThereEmergencyEquipment: formElement(closedSpaceChecklist.isThereEmergencyEquipment),
            willThereBeRescuePlan: formElement(closedSpaceChecklist.willThereBeRescuePlan),
            willYouHaveARescueHarness: formElement(closedSpaceChecklist.willYouHaveARescueHarness),
            willThereBeEmergencyEquipment: formElement(closedSpaceChecklist.willThereBeEmergencyEquipment),
            isTrainedManHoleGuardAvailable: formElement(closedSpaceChecklist.isTrainedManHoleGuardAvailable),
            isOtherPersonnelAtEntry: formElement(closedSpaceChecklist.isOtherPersonnelAtEntry),
            willGasMeasurementsBePerformedAndDocumented: formElement(
                closedSpaceChecklist.willGasMeasurementsBePerformedAndDocumented
            ),
            areWarningSignsOnOpenings: formElement(closedSpaceChecklist.areWarningSignsOnOpenings)
        },
        divingChecklist: {
            divingPermitSequenceIdentifier: formElement(
                riskIdentifications.divingChecklist.divingPermitSequenceIdentifier
            )
        },
        excavationAndPolingChecklist: {
            canSafleyDecendShaft: formElement(excavationAndPolingChecklist.canSafleyDecendShaft),
            howIsAreaBlockedOff: formElement(excavationAndPolingChecklist.howIsAreaBlockedOff),
            isCablesInTheGround: formElement(excavationAndPolingChecklist.isCablesInTheGround),
            isDepperThan120Centimeters: formElement(excavationAndPolingChecklist.isDepperThan120Centimeters),
            isGasPartOfTheTest: formElement(excavationAndPolingChecklist.isGasPartOfTheTest),
            isManHoleGuardAvailable: formElement(excavationAndPolingChecklist.isManHoleGuardAvailable),
            isMassesOilContanimated: formElement(excavationAndPolingChecklist.isMassesOilContanimated),
            isProductPipesOrTheLikeInTheGround: formElement(
                excavationAndPolingChecklist.isProductPipesOrTheLikeInTheGround
            ),
            isReleaseDone: formElement(excavationAndPolingChecklist.isReleaseDone),
            isRiskOfRace: formElement(excavationAndPolingChecklist.isRiskOfRace),
            isSubmittedToCountyBoard: formElement(excavationAndPolingChecklist.isSubmittedToCountyBoard),
            isTestsDoneForLab: formElement(excavationAndPolingChecklist.isTestsDoneForLab),
            isGasTestedInHoleBeforeEntry: formElement(excavationAndPolingChecklist.isGasTestedInHoleBeforeEntry),
            isSubmittedToCountyBoardForExcavation: formElement(
                excavationAndPolingChecklist.isSubmittedToCountyBoardForExcavation
            ),
            isTrainedExcavationGuardAvailable: formElement(
                excavationAndPolingChecklist.isTrainedExcavationGuardAvailable
            )
        },
        heavyLiftingChecklist: {
            hasInfraDoneExposuresOnQuay: formElement(heavyLiftingChecklist.hasInfraDoneExposuresOnQuay),
            ifApprovedByInfraName: formElement(heavyLiftingChecklist.ifApprovedByInfraName),
            ifApprovedByInfraNumber: formElement(heavyLiftingChecklist.ifApprovedByInfraNumber),
            isApprovedByInfra: formElement(heavyLiftingChecklist.isApprovedByInfra),
            isControlLineAvailable: formElement(heavyLiftingChecklist.isControlLineAvailable),
            isCrainOperatorEducated: formElement(heavyLiftingChecklist.isCrainOperatorEducated),
            isEquipmentTested: formElement(heavyLiftingChecklist.isEquipmentTested),
            isGroundGotBearingCapcity: formElement(heavyLiftingChecklist.isGroundGotBearingCapcity),
            isInfraContacted: formElement(heavyLiftingChecklist.isInfraContacted),
            isLiftAreaShutOff: formElement(heavyLiftingChecklist.isLiftAreaShutOff),
            isLiftingHookOpen: formElement(heavyLiftingChecklist.isLiftingHookOpen),
            isLiftLineCorrectForTheWeight: formElement(heavyLiftingChecklist.isLiftLineCorrectForTheWeight),
            isLiftLineInGoodCondition: formElement(heavyLiftingChecklist.isLiftLineInGoodCondition),
            isLiftPlanInPlace: formElement(heavyLiftingChecklist.isLiftPlanInPlace),
            isRiskanalysDone: formElement(heavyLiftingChecklist.isRiskanalysDone),
            isSignalmanChoosen: formElement(heavyLiftingChecklist.isSignalmanChoosen),
            isSupportLegsCorrect: formElement(heavyLiftingChecklist.isSupportLegsCorrect),
            isVehicleAroundRorgatan: formElement(heavyLiftingChecklist.isVehicleAroundRorgatan),
            isWorkDoneBeneathLoad: formElement(heavyLiftingChecklist.isWorkDoneBeneathLoad),
            isInfrastructureDepartmentContacted: formElement(heavyLiftingChecklist.isInfrastructureDepartmentContacted),
            isOpenLiftingHookUsed: formElement(heavyLiftingChecklist.isOpenLiftingHookUsed),
            isLiftAreaShutOff_Cones: formElement(heavyLiftingChecklist.isLiftAreaShutOff_Cones),
            isLiftAreaShutOff_Tape: formElement(heavyLiftingChecklist.isLiftAreaShutOff_Tape),
            isLiftAreaShutOff_NA: formElement(heavyLiftingChecklist.isLiftAreaShutOff_NA)
        },
        hydrogenSulphideChecklist: {
            isContinousGasMeasurementsInPlace: formElement(hydrogenSulphideChecklist.isContinousGasMeasurementsInPlace),
            isContinuousVentilationInPlace: formElement(hydrogenSulphideChecklist.isContinuousVentilationInPlace),
            isEscapeMasksAvailable: formElement(hydrogenSulphideChecklist.isEscapeMasksAvailable),
            isPortalHydroGenSulphideAlarmAvailable: formElement(
                hydrogenSulphideChecklist.isPortalHydroGenSulphideAlarmAvailable
            ),
            isWindDirectionThoughtOf: formElement(hydrogenSulphideChecklist.isWindDirectionThoughtOf),
            isFreshAirMaskNeededDuringWork: formElement(hydrogenSulphideChecklist.isFreshAirMaskNeededDuringWork),
            isContinuousVentilationNeeded: formElement(hydrogenSulphideChecklist.isContinuousVentilationNeeded),
            isEscapeMasksAvailableForAllInvolved: formElement(
                hydrogenSulphideChecklist.isEscapeMasksAvailableForAllInvolved
            ),
            isHydrogenSulphideGasMeterAvailable: formElement(
                hydrogenSulphideChecklist.isHydrogenSulphideGasMeterAvailable
            ),
            isContinousGasMeasurementsInPlaceForEntirityOfWork: formElement(
                hydrogenSulphideChecklist.isContinousGasMeasurementsInPlaceForEntirityOfWork
            ),
            isWindDirectionConsideredDuringWork: formElement(
                hydrogenSulphideChecklist.isWindDirectionConsideredDuringWork
            )
        },
        interventionOnProcessEquipment: formElement(riskIdentifications.interventionOnProcessEquipment),
        isAsbestosIncludedInPrint: formElement(riskIdentifications.isAsbestosIncludedInPrint),
        isBeefGasIncludedInPrint: formElement(riskIdentifications.isBeefGasIncludedInPrint),
        isClosedSpaceIncludedInPrint: formElement(riskIdentifications.isClosedSpaceIncludedInPrint),
        isDivingIncludedInPrint: formElement(riskIdentifications.isDivingIncludedInPrint),
        isExcavationAndPolingIncludedInPrint: formElement(riskIdentifications.isExcavationAndPolingIncludedInPrint),
        isHeavyLiftingIncludedInPrint: formElement(riskIdentifications.isHeavyLiftingIncludedInPrint),
        isHydrogenSulphideIncludedInPrint: formElement(riskIdentifications.isHydrogenSulphideIncludedInPrint),
        isRaftIncludedInPrint: formElement(riskIdentifications.isRaftIncludedInPrint),
        isScaffoldingIncludedInPrint: formElement(riskIdentifications.isScaffoldingIncludedInPrint),
        isWorkAtHeightIncludedInPrint: formElement(riskIdentifications.isWorkAtHeightIncludedInPrint),
        raftChecklist: {
            underWaterWorkPermitSequenceIdentifier: formElement(
                riskIdentifications.raftChecklist.underWaterWorkPermitSequenceIdentifier
            )
        },
        scaffoldingChecklist: {
            areEscapeRoutesCleared: formElement(scaffoldingChecklist.areEscapeRoutesCleared),
            doesScaffoldHaveDamage: formElement(scaffoldingChecklist.doesScaffoldHaveDamage),
            doesScaffoldHaveSufficientRailing: formElement(scaffoldingChecklist.doesScaffoldHaveSufficientRailing),
            ifPassageAffectedIsMarked: formElement(scaffoldingChecklist.ifPassageAffectedIsMarked),
            isConnectedProperly: formElement(scaffoldingChecklist.isConnectedProperly),
            isHarnessInspected: formElement(scaffoldingChecklist.isHarnessInspected),
            isHarnessNeeded: formElement(scaffoldingChecklist.isHarnessNeeded),
            isIceOnScaffold: formElement(scaffoldingChecklist.isIceOnScaffold),
            isLadderHigherThan4MetersAndBackProtection: formElement(
                scaffoldingChecklist.isLadderHigherThan4MetersAndBackProtection
            ),
            isOilSpillOnScaffold: formElement(scaffoldingChecklist.isOilSpillOnScaffold),
            isPassageAffectedByScaffold: formElement(scaffoldingChecklist.isPassageAffectedByScaffold),
            isScaffoldApproved: formElement(scaffoldingChecklist.isScaffoldApproved),
            isThereRiskOfStepThrough: formElement(scaffoldingChecklist.isThereRiskOfStepThrough),
            noLoosePlanksOnScaffold: formElement(scaffoldingChecklist.noLoosePlanksOnScaffold),
            willScaffoldsBeBuiltInPumpingStation: formElement(scaffoldingChecklist.willScaffoldsBeBuiltInPumpingStation)
        },
        scaffoldingConstruction: formElement(riskIdentifications.scaffoldingConstruction),
        scaffoldingConstructionChecklist: {
            willBeBuiltInPumpingStation: formElement(scaffoldingConstructionChecklist.willBeBuiltInPumpingStation),
            willBeBuiltOnQuay: formElement(scaffoldingConstructionChecklist.willBeBuiltOnQuay),
            isFallProtectionHarnessNeeded: formElement(scaffoldingConstructionChecklist.isFallProtectionHarnessNeeded),
            isHarnessInspectedWithinOneYear: formElement(
                scaffoldingConstructionChecklist.isHarnessInspectedWithinOneYear
            ),
            isSecurelyConnectedToFallProtection: formElement(
                scaffoldingConstructionChecklist.isSecurelyConnectedToFallProtection
            ),
            willHaveApprovedValidityCertificate: formElement(
                scaffoldingConstructionChecklist.willHaveApprovedValidityCertificate
            ),
            willHaveSufficientlyHighGuardRails: formElement(
                scaffoldingConstructionChecklist.willHaveSufficientlyHighGuardRails
            ),
            willToeboardsBeMounted: formElement(scaffoldingConstructionChecklist.willToeboardsBeMounted),
            willHaveLoosePlanks: formElement(scaffoldingConstructionChecklist.willHaveLoosePlanks),
            isRiskOfSteppingThroughAfterCompletion: formElement(
                scaffoldingConstructionChecklist.isRiskOfSteppingThroughAfterCompletion
            ),
            isBackProtectionMountedIfLadderAbove4m: formElement(
                scaffoldingConstructionChecklist.isBackProtectionMountedIfLadderAbove4m
            ),
            areEscapeRoutesCleared: formElement(scaffoldingConstructionChecklist.areEscapeRoutesCleared),
            hasScaffoldingDamage: formElement(scaffoldingConstructionChecklist.hasScaffoldingDamage),
            hasOilSpill: formElement(scaffoldingConstructionChecklist.hasOilSpill),
            hasIce: formElement(scaffoldingConstructionChecklist.hasIce),
            isPassageAffectedByScaffolding: formElement(
                scaffoldingConstructionChecklist.isPassageAffectedByScaffolding
            ),
            isPassageMarkedAndCollisionProtectionInstalled: formElement(
                scaffoldingConstructionChecklist.isPassageMarkedAndCollisionProtectionInstalled
            )
        },
        scaffoldingWork: formElement(riskIdentifications.scaffoldingWork),
        scaffoldingWorkChecklist: {
            areEscapeRoutesCleared: formElement(scaffoldingWorkChecklist.areEscapeRoutesCleared),
            hasApprovedValidityCertificate: formElement(scaffoldingWorkChecklist.hasApprovedValidityCertificate),
            hasSufficientlyHighGuardRails: formElement(scaffoldingWorkChecklist.hasSufficientlyHighGuardRails),
            hasIce: formElement(scaffoldingWorkChecklist.hasIce),
            hasLoosePlanks: formElement(scaffoldingWorkChecklist.hasLoosePlanks),
            hasOilSpill: formElement(scaffoldingWorkChecklist.hasOilSpill),
            isBackProtectionMountedIfLadderAbove4m: formElement(
                scaffoldingWorkChecklist.isBackProtectionMountedIfLadderAbove4m
            ),
            isRiskOfSteppingThrough: formElement(scaffoldingWorkChecklist.isRiskOfSteppingThrough),
            hasScaffoldingDamage: formElement(scaffoldingWorkChecklist.hasScaffoldingDamage),
            hasToeboards: formElement(scaffoldingWorkChecklist.hasToeboards)
        },
        workAtHeightChecklist: {
            areEscapeRoutesCleared: formElement(workAtHeightChecklist.areEscapeRoutesCleared),
            haveCorrectFallProtection: formElement(workAtHeightChecklist.haveCorrectFallProtection),
            isAreaCordonedOff: formElement(workAtHeightChecklist.isAreaCordonedOff),
            isConnectedProperly: formElement(workAtHeightChecklist.isConnectedProperly),
            isHarnessInspected: formElement(workAtHeightChecklist.isHarnessInspected),
            isRiskOfDebris: formElement(workAtHeightChecklist.isRiskOfDebris),
            isRiskOfFallingObjects: formElement(workAtHeightChecklist.isRiskOfFallingObjects),
            needsProtectiveNet: formElement(workAtHeightChecklist.needsProtectiveNet),
            willBeLooseObjects: formElement(workAtHeightChecklist.willBeLooseObjects),
            willBeLooseObjectsComment: formElement(workAtHeightChecklist.willBeLooseObjectsComment),
            howIsAreaBelowCordonedOff: formElement(workAtHeightChecklist.howIsAreaBelowCordonedOff),
            isSecurelyConnectedToFallProtection: formElement(workAtHeightChecklist.isSecurelyConnectedToFallProtection),
            isHarnessInspectedWithinOneYear: formElement(workAtHeightChecklist.isHarnessInspectedWithinOneYear),
            howAreLooseObjectsSecured: formElement(workAtHeightChecklist.howAreLooseObjectsSecured)
        }
    };
}

export function RiskIdentifications_normalize(riskIdentifications: RiskIdentifications): RiskIdentifications {
    const normalizedRiskIdentifications: RiskIdentifications = {
        heavyLiftingChecklist: {
            craneOperatorSignature: Signature_normalize(
                riskIdentifications.heavyLiftingChecklist.craneOperatorSignature,
                SignatureType.CraneOperator
            ),
            hasInfraDoneExposuresOnQuay:
                riskIdentifications.heavyLiftingChecklist.hasInfraDoneExposuresOnQuay ?? RadioButtonOption.None,
            ifApprovedByInfraName: riskIdentifications.heavyLiftingChecklist.ifApprovedByInfraName ?? "",
            ifApprovedByInfraNumber: riskIdentifications.heavyLiftingChecklist.ifApprovedByInfraNumber ?? "",
            isApprovedByInfra: riskIdentifications.heavyLiftingChecklist.isApprovedByInfra ?? RadioButtonOption.None,
            isControlLineAvailable:
                riskIdentifications.heavyLiftingChecklist.isControlLineAvailable ?? RadioButtonOption.None,
            isCrainOperatorEducated:
                riskIdentifications.heavyLiftingChecklist.isCrainOperatorEducated ?? RadioButtonOption.None,
            isEquipmentTested: riskIdentifications.heavyLiftingChecklist.isEquipmentTested ?? RadioButtonOption.None,
            isGroundGotBearingCapcity:
                riskIdentifications.heavyLiftingChecklist.isGroundGotBearingCapcity ?? RadioButtonOption.None,
            isInfraContacted: riskIdentifications.heavyLiftingChecklist.isInfraContacted ?? RadioButtonOption.None,
            isLiftAreaShutOff: riskIdentifications.heavyLiftingChecklist.isLiftAreaShutOff ?? RadioButtonOption.None,
            isLiftingHookOpen: riskIdentifications.heavyLiftingChecklist.isLiftingHookOpen ?? RadioButtonOption.None,
            isLiftLineCorrectForTheWeight:
                riskIdentifications.heavyLiftingChecklist.isLiftLineCorrectForTheWeight ?? RadioButtonOption.None,
            isLiftLineInGoodCondition:
                riskIdentifications.heavyLiftingChecklist.isLiftLineInGoodCondition ?? RadioButtonOption.None,
            isLiftPlanInPlace: riskIdentifications.heavyLiftingChecklist.isLiftPlanInPlace ?? RadioButtonOption.None,
            isRiskanalysDone: riskIdentifications.heavyLiftingChecklist.isRiskanalysDone ?? RadioButtonOption.None,
            isSignalmanChoosen: riskIdentifications.heavyLiftingChecklist.isSignalmanChoosen ?? RadioButtonOption.None,
            isSupportLegsCorrect:
                riskIdentifications.heavyLiftingChecklist.isSupportLegsCorrect ?? RadioButtonOption.None,
            isVehicleAroundRorgatan:
                riskIdentifications.heavyLiftingChecklist.isVehicleAroundRorgatan ?? RadioButtonOption.None,
            isWorkDoneBeneathLoad:
                riskIdentifications.heavyLiftingChecklist.isWorkDoneBeneathLoad ?? RadioButtonOption.None,
            checklistVersion: riskIdentifications.heavyLiftingChecklist.checklistVersion ?? 0,
            isInfrastructureDepartmentContacted:
                riskIdentifications.heavyLiftingChecklist.isInfrastructureDepartmentContacted ?? RadioButtonOption.None,
            isLiftAreaShutOff_Cones: !!riskIdentifications.heavyLiftingChecklist.isLiftAreaShutOff_Cones,
            isLiftAreaShutOff_NA: !!riskIdentifications.heavyLiftingChecklist.isLiftAreaShutOff_NA,
            isLiftAreaShutOff_Tape: !!riskIdentifications.heavyLiftingChecklist.isLiftAreaShutOff_Tape,
            isOpenLiftingHookUsed:
                riskIdentifications.heavyLiftingChecklist.isOpenLiftingHookUsed ?? RadioButtonOption.None
        },
        asbetestosChecklist: {
            checklistVersion: riskIdentifications.asbetestosChecklist.checklistVersion ?? 0,
            areMasksFittedForRespPerson:
                riskIdentifications.asbetestosChecklist.areMasksFittedForRespPerson ?? RadioButtonOption.None,
            areOwnMachinesUsedForSanitation:
                riskIdentifications.asbetestosChecklist.areOwnMachinesUsedForSanitation ?? RadioButtonOption.None,
            externalPersonalIsContracted:
                riskIdentifications.asbetestosChecklist.externalPersonalIsContracted ?? RadioButtonOption.None,
            hasApprovalFromEnvironmentalAgency:
                riskIdentifications.asbetestosChecklist.hasApprovalFromEnvironmentalAgency ?? RadioButtonOption.None,
            hasCorrectDocuments: riskIdentifications.asbetestosChecklist.hasCorrectDocuments ?? RadioButtonOption.None,
            hasSignForAsbestos: riskIdentifications.asbetestosChecklist.hasSignForAsbestos ?? RadioButtonOption.None,
            isSanitisedFromAsbestosDust:
                riskIdentifications.asbetestosChecklist.isSanitisedFromAsbestosDust ?? RadioButtonOption.None,
            isTotalTimeForSanitationMoreThanOneHour:
                riskIdentifications.asbetestosChecklist.isTotalTimeForSanitationMoreThanOneHour ??
                RadioButtonOption.None,
            isWholeMaskWithCompressedAirUsed:
                riskIdentifications.asbetestosChecklist.isWholeMaskWithCompressedAirUsed ?? RadioButtonOption.None,
            leaderAndPersonalHaveCorrectEducation:
                riskIdentifications.asbetestosChecklist.leaderAndPersonalHaveCorrectEducation ?? RadioButtonOption.None,
            masksAreStoredAccordingAccordingToRules:
                riskIdentifications.asbetestosChecklist.masksAreStoredAccordingAccordingToRules ??
                RadioButtonOption.None,
            hasApprovalForThisProject:
                riskIdentifications.asbetestosChecklist.hasApprovalForThisProject ?? RadioButtonOption.None
        },
        beefGasChecklist: {
            isContinousGasMeasurementsInPlace:
                riskIdentifications.beefGasChecklist.isContinousGasMeasurementsInPlace ?? RadioButtonOption.None,
            isContinuousVentilationInPlace:
                riskIdentifications.beefGasChecklist.isContinuousVentilationInPlace ?? RadioButtonOption.None,
            isFreshAirMaskForEveryone:
                riskIdentifications.beefGasChecklist.isFreshAirMaskForEveryone ?? RadioButtonOption.None,
            isPortableGasMeasurementAlarmAvailableForEveryone:
                riskIdentifications.beefGasChecklist.isPortableGasMeasurementAlarmAvailableForEveryone ??
                RadioButtonOption.None,
            needsFreshAirDevice: riskIdentifications.beefGasChecklist.needsFreshAirDevice ?? RadioButtonOption.None,
            checklistVersion: riskIdentifications.beefGasChecklist.checklistVersion ?? 0,
            isContinousGasMeasurementsInPlaceForEntirityOfWork:
                riskIdentifications.beefGasChecklist.isContinousGasMeasurementsInPlaceForEntirityOfWork ??
                RadioButtonOption.None,
            isContinuousVentilationNeeded:
                riskIdentifications.beefGasChecklist.isContinuousVentilationNeeded ?? RadioButtonOption.None,
            isFreshAirMaskNeededDuringWork:
                riskIdentifications.beefGasChecklist.isFreshAirMaskNeededDuringWork ?? RadioButtonOption.None,
            isOxygenLevelGasMeterAvailable:
                riskIdentifications.beefGasChecklist.isOxygenLevelGasMeterAvailable ?? RadioButtonOption.None,
            isWindDirectionConsideredDuringWork:
                riskIdentifications.beefGasChecklist.isWindDirectionConsideredDuringWork ?? RadioButtonOption.None
        },
        closedSpaceChecklist: {
            checklistVersion: riskIdentifications.closedSpaceChecklist.checklistVersion ?? 0,
            areAllTermsMet: riskIdentifications.closedSpaceChecklist.areAllTermsMet ?? RadioButtonOption.None,
            areGasMeasurementsPerformed:
                riskIdentifications.closedSpaceChecklist.areGasMeasurementsPerformed ?? RadioButtonOption.None,
            areGasMeasurementsPerformedInClosedSpace:
                riskIdentifications.closedSpaceChecklist.areGasMeasurementsPerformedInClosedSpace ??
                RadioButtonOption.None,
            areWarningSignsOnManholes:
                riskIdentifications.closedSpaceChecklist.areWarningSignsOnManholes ?? RadioButtonOption.None,
            hasRescueHarness: riskIdentifications.closedSpaceChecklist.hasRescueHarness ?? RadioButtonOption.None,
            isLightningSufficient:
                riskIdentifications.closedSpaceChecklist.isLightningSufficient ?? RadioButtonOption.None,
            isManHoleGuardAvailable:
                riskIdentifications.closedSpaceChecklist.isManHoleGuardAvailable ?? RadioButtonOption.None,
            isMechanicalVentilation:
                riskIdentifications.closedSpaceChecklist.isMechanicalVentilation ?? RadioButtonOption.None,
            isPersonalAtEntryToClosedSpace:
                riskIdentifications.closedSpaceChecklist.isPersonalAtEntryToClosedSpace ?? RadioButtonOption.None,
            isThereARescuePlan: riskIdentifications.closedSpaceChecklist.isThereARescuePlan ?? RadioButtonOption.None,
            isThereEmergencyEquipment:
                riskIdentifications.closedSpaceChecklist.isThereEmergencyEquipment ?? RadioButtonOption.None,
            willThereBeRescuePlan:
                riskIdentifications.closedSpaceChecklist.willThereBeRescuePlan ?? RadioButtonOption.None,
            willYouHaveARescueHarness:
                riskIdentifications.closedSpaceChecklist.willYouHaveARescueHarness ?? RadioButtonOption.None,
            willThereBeEmergencyEquipment:
                riskIdentifications.closedSpaceChecklist.willThereBeEmergencyEquipment ?? RadioButtonOption.None,
            isTrainedManHoleGuardAvailable:
                riskIdentifications.closedSpaceChecklist.isTrainedManHoleGuardAvailable ?? RadioButtonOption.None,
            isOtherPersonnelAtEntry:
                riskIdentifications.closedSpaceChecklist.isOtherPersonnelAtEntry ?? RadioButtonOption.None,
            willGasMeasurementsBePerformedAndDocumented:
                riskIdentifications.closedSpaceChecklist.willGasMeasurementsBePerformedAndDocumented ??
                RadioButtonOption.None,
            areWarningSignsOnOpenings:
                riskIdentifications.closedSpaceChecklist.areWarningSignsOnOpenings ?? RadioButtonOption.None
        },
        divingChecklist: {
            divingPermitSequenceIdentifier: riskIdentifications.divingChecklist.divingPermitSequenceIdentifier ?? "",
            fromDivingPermitDocumentId: riskIdentifications.divingChecklist.fromDivingPermitDocumentId
        },
        excavationAndPolingChecklist: {
            canSafleyDecendShaft:
                riskIdentifications.excavationAndPolingChecklist.canSafleyDecendShaft ?? RadioButtonOption.None,
            howIsAreaBlockedOff: riskIdentifications.excavationAndPolingChecklist.howIsAreaBlockedOff ?? "",
            isCablesInTheGround:
                riskIdentifications.excavationAndPolingChecklist.isCablesInTheGround ?? RadioButtonOption.None,
            isDepperThan120Centimeters:
                riskIdentifications.excavationAndPolingChecklist.isDepperThan120Centimeters ?? RadioButtonOption.None,
            isGasPartOfTheTest:
                riskIdentifications.excavationAndPolingChecklist.isGasPartOfTheTest ?? RadioButtonOption.None,
            isManHoleGuardAvailable:
                riskIdentifications.excavationAndPolingChecklist.isManHoleGuardAvailable ?? RadioButtonOption.None,
            isMassesOilContanimated:
                riskIdentifications.excavationAndPolingChecklist.isMassesOilContanimated ?? RadioButtonOption.None,
            isProductPipesOrTheLikeInTheGround:
                riskIdentifications.excavationAndPolingChecklist.isProductPipesOrTheLikeInTheGround ??
                RadioButtonOption.None,
            isReleaseDone: riskIdentifications.excavationAndPolingChecklist.isReleaseDone ?? RadioButtonOption.None,
            isRiskOfRace: riskIdentifications.excavationAndPolingChecklist.isRiskOfRace ?? RadioButtonOption.None,
            isSubmittedToCountyBoard:
                riskIdentifications.excavationAndPolingChecklist.isSubmittedToCountyBoard ?? RadioButtonOption.None,
            isTestsDoneForLab:
                riskIdentifications.excavationAndPolingChecklist.isTestsDoneForLab ?? RadioButtonOption.None,
            checklistVersion: riskIdentifications.excavationAndPolingChecklist.checklistVersion ?? 0,
            isGasTestedInHoleBeforeEntry:
                riskIdentifications.excavationAndPolingChecklist.isGasTestedInHoleBeforeEntry ?? RadioButtonOption.None,
            isSubmittedToCountyBoardForExcavation:
                riskIdentifications.excavationAndPolingChecklist.isSubmittedToCountyBoardForExcavation ??
                RadioButtonOption.None,
            isTrainedExcavationGuardAvailable:
                riskIdentifications.excavationAndPolingChecklist.isTrainedExcavationGuardAvailable ??
                RadioButtonOption.None
        },
        hydrogenSulphideChecklist: {
            isContinousGasMeasurementsInPlace:
                riskIdentifications.hydrogenSulphideChecklist.isContinousGasMeasurementsInPlace ??
                RadioButtonOption.None,
            isContinuousVentilationInPlace:
                riskIdentifications.hydrogenSulphideChecklist.isContinuousVentilationInPlace ?? RadioButtonOption.None,
            isEscapeMasksAvailable:
                riskIdentifications.hydrogenSulphideChecklist.isEscapeMasksAvailable ?? RadioButtonOption.None,
            isPortalHydroGenSulphideAlarmAvailable:
                riskIdentifications.hydrogenSulphideChecklist.isPortalHydroGenSulphideAlarmAvailable ??
                RadioButtonOption.None,
            isWindDirectionThoughtOf:
                riskIdentifications.hydrogenSulphideChecklist.isWindDirectionThoughtOf ?? RadioButtonOption.None,
            checklistVersion: riskIdentifications.hydrogenSulphideChecklist.checklistVersion ?? 0,
            isContinousGasMeasurementsInPlaceForEntirityOfWork:
                riskIdentifications.hydrogenSulphideChecklist.isContinousGasMeasurementsInPlaceForEntirityOfWork ??
                RadioButtonOption.None,
            isContinuousVentilationNeeded:
                riskIdentifications.hydrogenSulphideChecklist.isContinuousVentilationNeeded ?? RadioButtonOption.None,
            isEscapeMasksAvailableForAllInvolved:
                riskIdentifications.hydrogenSulphideChecklist.isEscapeMasksAvailableForAllInvolved ??
                RadioButtonOption.None,
            isFreshAirMaskNeededDuringWork:
                riskIdentifications.hydrogenSulphideChecklist.isFreshAirMaskNeededDuringWork ?? RadioButtonOption.None,
            isHydrogenSulphideGasMeterAvailable:
                riskIdentifications.hydrogenSulphideChecklist.isHydrogenSulphideGasMeterAvailable ??
                RadioButtonOption.None,
            isWindDirectionConsideredDuringWork:
                riskIdentifications.hydrogenSulphideChecklist.isWindDirectionConsideredDuringWork ??
                RadioButtonOption.None
        },
        interventionOnProcessEquipment: riskIdentifications.interventionOnProcessEquipment ?? false,
        isAsbestosIncludedInPrint: riskIdentifications.isAsbestosIncludedInPrint ?? false,
        isBeefGasIncludedInPrint: riskIdentifications.isBeefGasIncludedInPrint ?? false,
        isClosedSpaceIncludedInPrint: riskIdentifications.isClosedSpaceIncludedInPrint ?? false,
        isDivingIncludedInPrint: riskIdentifications.isDivingIncludedInPrint ?? false,
        isExcavationAndPolingIncludedInPrint: riskIdentifications.isExcavationAndPolingIncludedInPrint ?? false,
        isHeavyLiftingIncludedInPrint: riskIdentifications.isHeavyLiftingIncludedInPrint ?? false,
        isHydrogenSulphideIncludedInPrint: riskIdentifications.isHydrogenSulphideIncludedInPrint ?? false,
        isRaftIncludedInPrint: riskIdentifications.isRaftIncludedInPrint ?? false,
        isScaffoldingIncludedInPrint: riskIdentifications.isScaffoldingIncludedInPrint ?? false,
        isWorkAtHeightIncludedInPrint: riskIdentifications.isWorkAtHeightIncludedInPrint ?? false,
        raftChecklist: {
            underWaterWorkPermitSequenceIdentifier:
                riskIdentifications.raftChecklist.underWaterWorkPermitSequenceIdentifier ?? ""
        },
        scaffoldingChecklist: {
            areEscapeRoutesCleared:
                riskIdentifications.scaffoldingChecklist.areEscapeRoutesCleared ?? RadioButtonOption.None,
            doesScaffoldHaveDamage:
                riskIdentifications.scaffoldingChecklist.doesScaffoldHaveDamage ?? RadioButtonOption.None,
            doesScaffoldHaveSufficientRailing:
                riskIdentifications.scaffoldingChecklist.doesScaffoldHaveSufficientRailing ?? RadioButtonOption.None,
            ifPassageAffectedIsMarked:
                riskIdentifications.scaffoldingChecklist.ifPassageAffectedIsMarked ?? RadioButtonOption.None,
            isConnectedProperly: riskIdentifications.scaffoldingChecklist.isConnectedProperly ?? RadioButtonOption.None,
            isHarnessInspected: riskIdentifications.scaffoldingChecklist.isHarnessInspected ?? RadioButtonOption.None,
            isHarnessNeeded: riskIdentifications.scaffoldingChecklist.isHarnessNeeded ?? RadioButtonOption.None,
            isIceOnScaffold: riskIdentifications.scaffoldingChecklist.isIceOnScaffold ?? RadioButtonOption.None,
            isLadderHigherThan4MetersAndBackProtection:
                riskIdentifications.scaffoldingChecklist.isLadderHigherThan4MetersAndBackProtection ??
                RadioButtonOption.None,
            isOilSpillOnScaffold:
                riskIdentifications.scaffoldingChecklist.isOilSpillOnScaffold ?? RadioButtonOption.None,
            isPassageAffectedByScaffold:
                riskIdentifications.scaffoldingChecklist.isPassageAffectedByScaffold ?? RadioButtonOption.None,
            isScaffoldApproved: riskIdentifications.scaffoldingChecklist.isScaffoldApproved ?? RadioButtonOption.None,
            isThereRiskOfStepThrough:
                riskIdentifications.scaffoldingChecklist.isThereRiskOfStepThrough ?? RadioButtonOption.None,
            noLoosePlanksOnScaffold:
                riskIdentifications.scaffoldingChecklist.noLoosePlanksOnScaffold ?? RadioButtonOption.None,
            willScaffoldsBeBuiltInPumpingStation:
                riskIdentifications.scaffoldingChecklist.willScaffoldsBeBuiltInPumpingStation ?? RadioButtonOption.None
        },
        scaffoldingConstruction: riskIdentifications.scaffoldingConstruction ?? false,
        scaffoldingConstructionChecklist: {
            checklistVersion: riskIdentifications.scaffoldingConstructionChecklist.checklistVersion ?? 0,
            willBeBuiltInPumpingStation:
                riskIdentifications.scaffoldingConstructionChecklist.willBeBuiltInPumpingStation ??
                RadioButtonOption.None,
            willBeBuiltOnQuay:
                riskIdentifications.scaffoldingConstructionChecklist.willBeBuiltOnQuay ?? RadioButtonOption.None,
            isFallProtectionHarnessNeeded:
                riskIdentifications.scaffoldingConstructionChecklist.isFallProtectionHarnessNeeded ??
                RadioButtonOption.None,
            isHarnessInspectedWithinOneYear:
                riskIdentifications.scaffoldingConstructionChecklist.isHarnessInspectedWithinOneYear ??
                RadioButtonOption.None,
            isSecurelyConnectedToFallProtection:
                riskIdentifications.scaffoldingConstructionChecklist.isSecurelyConnectedToFallProtection ??
                RadioButtonOption.None,
            willHaveApprovedValidityCertificate:
                riskIdentifications.scaffoldingConstructionChecklist.willHaveApprovedValidityCertificate ??
                RadioButtonOption.None,
            willHaveSufficientlyHighGuardRails:
                riskIdentifications.scaffoldingConstructionChecklist.willHaveSufficientlyHighGuardRails ??
                RadioButtonOption.None,
            willToeboardsBeMounted:
                riskIdentifications.scaffoldingConstructionChecklist.willToeboardsBeMounted ?? RadioButtonOption.None,
            willHaveLoosePlanks:
                riskIdentifications.scaffoldingConstructionChecklist.willHaveLoosePlanks ?? RadioButtonOption.None,
            isRiskOfSteppingThroughAfterCompletion:
                riskIdentifications.scaffoldingConstructionChecklist.isRiskOfSteppingThroughAfterCompletion ??
                RadioButtonOption.None,
            isBackProtectionMountedIfLadderAbove4m:
                riskIdentifications.scaffoldingConstructionChecklist.isBackProtectionMountedIfLadderAbove4m ??
                RadioButtonOption.None,
            areEscapeRoutesCleared:
                riskIdentifications.scaffoldingConstructionChecklist.areEscapeRoutesCleared ?? RadioButtonOption.None,
            hasScaffoldingDamage:
                riskIdentifications.scaffoldingConstructionChecklist.hasScaffoldingDamage ?? RadioButtonOption.None,
            hasOilSpill: riskIdentifications.scaffoldingConstructionChecklist.hasOilSpill ?? RadioButtonOption.None,
            hasIce: riskIdentifications.scaffoldingConstructionChecklist.hasIce ?? RadioButtonOption.None,
            isPassageAffectedByScaffolding:
                riskIdentifications.scaffoldingConstructionChecklist.isPassageAffectedByScaffolding ??
                RadioButtonOption.None,
            isPassageMarkedAndCollisionProtectionInstalled:
                riskIdentifications.scaffoldingConstructionChecklist.isPassageMarkedAndCollisionProtectionInstalled ??
                RadioButtonOption.None
        },
        scaffoldingWork: riskIdentifications.scaffoldingWork ?? false,
        scaffoldingWorkChecklist: {
            checklistVersion: riskIdentifications.scaffoldingWorkChecklist.checklistVersion ?? 0,
            hasApprovedValidityCertificate:
                riskIdentifications.scaffoldingWorkChecklist.hasApprovedValidityCertificate ?? RadioButtonOption.None,
            hasSufficientlyHighGuardRails:
                riskIdentifications.scaffoldingWorkChecklist.hasSufficientlyHighGuardRails ?? RadioButtonOption.None,
            hasToeboards: riskIdentifications.scaffoldingWorkChecklist.hasToeboards ?? RadioButtonOption.None,
            hasLoosePlanks: riskIdentifications.scaffoldingWorkChecklist.hasLoosePlanks ?? RadioButtonOption.None,
            isRiskOfSteppingThrough:
                riskIdentifications.scaffoldingWorkChecklist.isRiskOfSteppingThrough ?? RadioButtonOption.None,
            isBackProtectionMountedIfLadderAbove4m:
                riskIdentifications.scaffoldingWorkChecklist.isBackProtectionMountedIfLadderAbove4m ??
                RadioButtonOption.None,
            areEscapeRoutesCleared:
                riskIdentifications.scaffoldingWorkChecklist.areEscapeRoutesCleared ?? RadioButtonOption.None,
            hasScaffoldingDamage:
                riskIdentifications.scaffoldingWorkChecklist.hasScaffoldingDamage ?? RadioButtonOption.None,
            hasOilSpill: riskIdentifications.scaffoldingWorkChecklist.hasOilSpill ?? RadioButtonOption.None,
            hasIce: riskIdentifications.scaffoldingWorkChecklist.hasIce ?? RadioButtonOption.None
        },
        workAtHeightChecklist: {
            areEscapeRoutesCleared:
                riskIdentifications.workAtHeightChecklist.areEscapeRoutesCleared ?? RadioButtonOption.None,
            haveCorrectFallProtection:
                riskIdentifications.workAtHeightChecklist.haveCorrectFallProtection ?? RadioButtonOption.None,
            isAreaCordonedOff: riskIdentifications.workAtHeightChecklist.isAreaCordonedOff ?? RadioButtonOption.None,
            isConnectedProperly:
                riskIdentifications.workAtHeightChecklist.isConnectedProperly ?? RadioButtonOption.None,
            isHarnessInspected: riskIdentifications.workAtHeightChecklist.isHarnessInspected ?? RadioButtonOption.None,
            isRiskOfDebris: riskIdentifications.workAtHeightChecklist.isRiskOfDebris ?? RadioButtonOption.None,
            isRiskOfFallingObjects:
                riskIdentifications.workAtHeightChecklist.isRiskOfFallingObjects ?? RadioButtonOption.None,
            needsProtectiveNet: riskIdentifications.workAtHeightChecklist.needsProtectiveNet ?? RadioButtonOption.None,
            willBeLooseObjects: riskIdentifications.workAtHeightChecklist.willBeLooseObjects ?? RadioButtonOption.None,
            willBeLooseObjectsComment: riskIdentifications.workAtHeightChecklist.willBeLooseObjectsComment ?? "",
            checklistVersion: riskIdentifications.workAtHeightChecklist.checklistVersion ?? 0,
            howIsAreaBelowCordonedOff: riskIdentifications.workAtHeightChecklist.howIsAreaBelowCordonedOff ?? "",
            isSecurelyConnectedToFallProtection:
                riskIdentifications.workAtHeightChecklist.isSecurelyConnectedToFallProtection ?? RadioButtonOption.None,
            isHarnessInspectedWithinOneYear:
                riskIdentifications.workAtHeightChecklist.isHarnessInspectedWithinOneYear ?? RadioButtonOption.None,
            howAreLooseObjectsSecured: riskIdentifications.workAtHeightChecklist.howAreLooseObjectsSecured ?? ""
        }
    };

    return normalizedRiskIdentifications;
}
